'use strict';

export function PermissionDomainProvider() {
  return {
    $get: [
      '$injector',
      'FirebaseUtil',
      'AbstractDomainClass',
      function ($injector, FirebaseUtil, AbstractDomainClass) {
        function PermissionDomain(data) {
          AbstractDomainClass.call(this, PermissionDomain, data);
        }

        AbstractDomainClass.__inheritFrom(PermissionDomain, 'PermissionDomain', '_permissions');

        //TODO: flag as immutable and not writable.
        PermissionDomain.$constraints.addConstraints({
          name: {type: 'string'},
          description: {type: 'string', widget: 'textarea'}
        });

        // more methods go here;

        PermissionDomain.prototype.toString = function toString() {
          return this.name;
        };

        return PermissionDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/domain/PermissionDomain.js